import { AxiosRequestConfig } from "axios";
import SiePedidosAuthService from "@/services/sie-pedidos/auth.service";

export const siePedidosHandleRequest = (config: AxiosRequestConfig) => {
  const token = SiePedidosAuthService.token;
  const authHeader = token ? `Bearer ${token}` : "";
  config.headers = {
    ...config.headers,
    Authorization: authHeader,
    Accept: "application/json",
    "Content-Type": "application/json"
  };

  return config;
};

export const siePedidosHandleErrorRequest = (error: any) =>
  Promise.reject(error);
